import {
  InformationBox,
  MuiBox,
  MuiButtonPrimary,
  MuiButtonSecondary,
  MuiGrid,
} from "../../../../components";
import { COMPONENT_IDS } from "../../../../helpers/constants/componentIds";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { nisParticipantHeaderSiteCoreKeys } from "../../../createNISParticipant/siteCore/SiteCoreKeys";
import { ViewNISParticipantHeaderWrapper } from "./ViewNISParticipantHeader.style";

interface ViewNISParticipantHeaderProps {
  onEditClick?: () => void; // Callback for the Edit button
  onConvertToProgramClick?: () => void; // Callback for the Secondary button
  hideEditButton?: boolean;
  showConvertToProgramButton?: boolean;
}

const ViewNISParticipantHeader = ({
  onEditClick,
  onConvertToProgramClick,
  hideEditButton = false,
  showConvertToProgramButton,
}: ViewNISParticipantHeaderProps) => {
  const { commonLabels, useFetchLabel } = useSiteCore();
  const {
    nisParticipantHeaderTitle,
    convertToProgramButton,
    viewNISParticipantHeader,
  } = nisParticipantHeaderSiteCoreKeys;

  const getLabel = useFetchLabel(nisParticipantHeaderTitle);
  return (
    <ViewNISParticipantHeaderWrapper>
      <MuiGrid container className="header-container">
        <MuiGrid size={{ sm: 6, xs: 12 }} className="header-left">
          <InformationBox title={getLabel(viewNISParticipantHeader)} />
        </MuiGrid>
        <MuiBox className="button-container">
          {showConvertToProgramButton && (
            <MuiButtonSecondary
              id={COMPONENT_IDS.CANCEL_BUTTON}
              onClick={onConvertToProgramClick}
            >
              {getLabel(convertToProgramButton)}
            </MuiButtonSecondary>
          )}
          {!hideEditButton && (
            <MuiButtonPrimary
              id={COMPONENT_IDS.UPDATE_BUTTON}
              onClick={onEditClick}
            >
              {commonLabels.edit}
            </MuiButtonPrimary>
          )}
        </MuiBox>
      </MuiGrid>
    </ViewNISParticipantHeaderWrapper>
  );
};

export default ViewNISParticipantHeader;
